package game.entity

import game.Game
import game.Room

class FinalPongBattle : Entity() {
    var step = 0

    val pong = PongBattle(
        PongBattleConfig(
            "paddle",
            "father-paddle",
            "small-shard",
            true,
            0.25,
            7,
            0.5,
            19.5,
        )
    ) {
        step++
    }

    override fun onInit(game: Game, room: Room) {
        room.addEntity(pong)
    }

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                // wait for done
            }
            1 -> {
                room.removeEntity(pong)
                game.startTeleportTransition(game.player.col, game.player.row, 25, 13, "maze-battle", true)
                room.removePermanently(game, this)
            }
        }
    }
}